export default __webpack_public_path__ + "static/media/stereo_12.f94435c9.gif";